import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setAccountId,
	setActiveReservation,
	setFirstNames,
	setOpenBills,
} from "../../../features/reservation/reservationSlice";
import ScanWristband from "../../../components/kiosk/ScanWristband";

export default function CheckOut() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	/**
	 * Get customer and reservation from ScanWristband
	 * Navigate to open bills, pre auth or directly to feedback
	 */
	const handleSubmit = (response: any) => {
		dispatch(setActiveReservation(response.data.ReservationId));
		dispatch(setOpenBills(response.data.OpenBills));
    dispatch(setAccountId(response.data.AccountId));
    dispatch(setFirstNames(response.data.FirstNames));

		/**
		 * Check if the guest has open bills
		 */
		if (response.data.OpenBills.Total.GrossValue > 0.1) {
			/**
			 * Create pos payment
			 */
			navigate("/kiosk/check-out/open-bills");
		} else {
			navigate("/kiosk/check-out/feedback");
		}
	};

	return (
		<div className="flex-grow flex justify-center items-center flex-col w-full">
			<div className="grid grid-cols-1 gap-12">
				<div className="text-h1 text-center">
					Please scan your wristband here.
				</div>
				<ScanWristband
					endpoint={"/reservation/before-check-out"}
					callBack={(token) => handleSubmit(token)}
				/>
			</div>
		</div>
	);
}
